/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import PropTypes from 'prop-types'


const HeroCTA = ({ heromain, herosub, herourl }) => (
    <div>
        <section className="hero is-bold">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-centered">
                            <div className="section home-content">
                             <div className ="has-text-centered">
                                    <h3 className="has-text-weight-semibold is-size-2 has-text-centered">
                                        {heromain}
                                    </h3>
                                </div> 
                                <br/>
                                <h5 className="has-text-weight-semibold is-size-4 has-text-centered">{herosub}</h5>
                                <br/>
                                <div className="buttons is-centered">
                                <a
                                    className="button is-large is-primary"
                                    href={herourl}>
                                    Sign Up
                                   
                                </a>   
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
        
                        
    </div>
);

HeroCTA.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            heromain: PropTypes.string,
            herosub: PropTypes.string,
            herourl: PropTypes.string,
        })
    ),
};

export default HeroCTA;



// WEBPACK FOOTER //
// ./src/components/HeroCTA/index.js